import { getEnv } from '@src/apis/shared';
import { getApiToken } from '@src/apis/reware/utils/tokenExchange';
import {
  StorefrontApi,
  Configuration,
} from '@troverecommerce/ps-storefront-api-client';

export const getStorefrontApiClient = async () => {
  const token = await getApiToken();

  const config = new Configuration({
    basePath: getEnv('STOREFRONT_API_BASE'),
    apiKey: token,
  });

  return new StorefrontApi(config);
};
